import { PropsWithChildren } from 'react';
import { ScreenSize, useScreenSize } from '@/ui/hooks/useScreenSize';
import { Col } from 'react-bootstrap';

import DropDownList from '@/ui/components/DropDownList';
import { getCSSVariableValue } from '@/domain/utils/CssExtractVariable';


interface ColumnWraperProps {
    title?: string;
}
/** Renderiza un wrapper dependiendo de si es mobile o desktop */
const ColumnWraper = ({ title = '', children }: PropsWithChildren<ColumnWraperProps>): JSX.Element => {

    /** Hook que contiene las dimensiones de la pantalla y maneja los componentes de acuerdo al resultado obtenido  */
    const { width, maxLargeWidth }: ScreenSize = useScreenSize();

    /** Variable que define si es entorno mobile o desktop */
    const isMobile: boolean = width < maxLargeWidth;
    const showVariantText = getCSSVariableValue('--show-text-footer-color-variant-light');
    const showVariantTextFooter = getCSSVariableValue('--footer-mobile-text');

    if (isMobile) {
        return (
            <DropDownList id='itemFooter4' title={title} classTitle={`${showVariantTextFooter} p-large-bold`}>
                {children}
            </DropDownList>
        );
    } else {
        return (
            <Col xs={3}>
                <ul className={`${showVariantText} list-unstyled mx-auto`}>
                    <span className='p-large-bold'>{title}</span>
                    <div>
                        {children}
                    </div>
                </ul>
            </Col>
        );
    }

}

export default ColumnWraper;